export interface FaqEntry {
  id: string
  question: string
  answer: string
}

export const enFaq: FaqEntry[] = [
  {
    id: 'what-is-radiri',
    question: 'What is Radiri?',
    answer: `Radiri provides local and regional news for people who live in a place but do not speak 
    the primary language of that place. We only report accurate facts, but the story writing and 
    content generation is done by our AI. This allows us to offer our online newspaper at a monthly 
    subscription fee of just 3 EUR per month—1/10th to 1/15th of typical subscription fees of 
    the digital edition of traditional, reputable, subcription-based newspapers in Europe.`,
  },
  {
    id: 'why-radiri',
    question: 'Why are you doing this?',
    answer: `We believe that local and regional news are under-appreciated and frequently
    overshadowed by emotionally charged reporting of global and geopolitical events.
    We also believe that people with limited access to local-language regional news are more
    likely to feel disconnected from the communities they live in, and more likely to be
    regarded as aliens by that community. We recognize that regular and reliable local-news
    reporting in languages other than the primary language of a place has not been 
    economically viable until now, and we want to change that with the help of AI.`,
  },
  {
    id: 'ai-reliability',
    question: 'I have heard that AI can make up things. Should I trust your news?',
    answer:
      `We use the AI for several purposes: To categorize source content into fact reporting,
      commentaries, opinions etc. To group source content by the event or facts they report on. To
      write original stories in the target language, without copying or translating. To generate 
      images, as pencil or charcoal drawings, to make the content inspiring and the newspaper
      easier to digest.

  Our AI is only used to process, summarize the inputs and compose the
      stories, strictly based on the inputs. It never contributes to the factual content of the news.`,
  },
  {
    id: 'data-sources',
    question: 'Where do you get your data?',
    answer:
      `Our system processes announcements and news available on the web, including public websites of 
      government agencies, museums, companies, and also other newspapers. We also process social
      media accounts of hand-selected reliable sources, such as government agencies, railway companies 
      and more.`,
  },
  {
    id: 'price',
    question: 'Why can you not offer access for free?',
    answer:
      `The only way to offer a free newspaper is by showing you ads. We will never show ads because
      we regard our readers as our customers, not as our product. Good journalism is paid for by
      its readers, not by people who want to influence those readers'  minds. 3 EUR for a high-quality
      newspaper is incredibly low compared to anything in existence as far as reputable,
      subscription-based newspapers are concerned. We do, however, believe that the economics of
      scale will allow us to reduce the price even further over time.`
  },
  {
    id: 'personal-data',
    question: 'What data do you collect about me?',
    answer:
      `We only store the minimum data required so you can access your subscription on multiple
      devices, and we can verify that you are a subscriber. This includes one email address you
      provide us with, which we do not least to avoid abuse by bots and fake accounts. (You can
      obviously provide us with an email alias that does not reveal your identity.) We do not share any
      of that data with anyone. We do not collect any data about what you read, search for, or click
      on. The reason we do not need this is that we do not show you any ads, so personalization
      is unnecessary.`
  },
  {
    id: 'political-bias',
    question: 'How do you avoid political bias?',
    answer:
      `Our AI is specifically designed to detect the degree of objectivity in source content, based on 
      source and style of writing: Commentary vs. expert opinion vs. fact reporting. For example, the
      announcement of a new exhibition, found on a known and hand-selected museum page will be regarded as a
      reliable fact, whereas opinions voiced in an interview published on a news website will be
      regarded as an opinion voiced by the interviewee. Social blogs and social media posts by individuals
      and influencers are not included in our sources at all, as a matter of principle.

We only generate stories based on source content detected as fact reporting. If we find
      commentaries made by publicly recognized sources, our AI may include them as a reference
      and with attribution, describing it as a commentary or opinion.`
  },
  {
    id: 'copyright',
    question: 'How do you protect intellectual property rights of your sources?',
    answer:
      `We never copy or translate text of original sources, except as direct quotations in 
      double quotation marks and with attribution. Our AI is specifically designed for detecting
      whether source content represents fact reporting vs. commentaries, opinions and literary
      work, and we only include fact reporting when deciding what to cover through our stories.
      Our AI writes original stories, separately for each language we support, using those facts
      as input, as opposed to copying or translating the originals.`
  },
  {
    id: 'ai-generated-images',
    question: 'Why do you use AI-generated images?',
    answer:
      `We don\'t have photographers on staff, and we don\'t want to steal images from others. 
      Like traditional media, publications use symbolic imagery to complement stories—a fire story 
      shows flames, not necessarily the actual scene. We use AI to generate these symbolic visuals 
      ethically and at low cost, capturing the essence of each story without requiring original photography 
      or licensing. We hope you find them engaging, helpful and, at times, entertaining. Please use
      the feedback buttons available for each image to let us know how you liked it!`,
  },
]
